export const parseCssValueToFloat = (
  css: CSSStyleDeclaration,
  attribute: string,
) => {
  return parseFloat(css.getPropertyValue(attribute));
};
